const applicationID = 'NKJP6H87O2';
const apiKey = '4a654cd89ec0665aecf805083e4c76d2';
const productIndex = 'mdm_catalog_fr_fr';
const betaProductIndex = 'beta_production_mdm_catalog_fr_fr';
const categoryIndex = 'mdm_suggestions';
const searchFiltersLabels = {
  'filters.filter_capacity.facet_label': {
    order: 10,
    label: 'Capacité'
  },
  'filters.filter_plus_product.facet_label': {
    order: 11,
    label: 'Le + produit'
  },
  'filters.filter_form.facet_label': {
    order: 6,
    label: 'Forme'
  },
  'filters.filter_ideal_for.facet_label': {
    order: 12,
    label: 'Idéal pour'
  },
  'filters.filter_model.facet_label': {
    order: 7,
    label: 'Modèle'
  },
  'filters.filter_theme.facet_label': {
    order: 8,
    label: 'Thème'
  },
  'segmentations.category_name': {
    order: 4,
    label: 'Catégorie'
  },
  'segmentations.colors.label': {
    order: 2,
    label: 'Couleur'
  },
  'segmentations.styles.label': {
    order: 3,
    label: 'Style'
  },
  'segmentations.fabrics.label': {
    order: 5,
    label: 'Matière'
  },
  'price.filtered_amount': {
    order: 1,
    label: 'Prix'
  },
  'segmentations.dimensions.depth': {
    order: 60,
    label: 'Profondeur max'
  },
  'segmentations.dimensions.height': {
    order: 60,
    label: 'Hauteur max'
  },
  'segmentations.dimensions.width': {
    order: 60,
    label: 'Largeur max'
  },
  dimensions: {
    order: 9,
    label: 'Dimension'
  },
  more_info: {
    order: 1,
    label: 'Les offres du moment'
  },
  is_eco_selection: 'Eco selection',
  is_in_stock: 'En stock',
  is_made_in_france: 'Made in France',
  is_on_sales: 'En promotion'
};
const searchFiltersLabelsBeta = {
  'sold_by.seller_name': {
    order: 630,
    label: 'Vendeur'
  },
  'filters.filter_eco_responsability.facet_label': {
    order: 520,
    label: 'Made In France'
  },
  'filters.filter_scent.facet_label': {
    order: 390,
    label: 'Parfum'
  },
  'filters.filter_bed_size.facet_label': {
    order: 100,
    label: 'Taille du couchage'
  },
  'filters.filter_bed_head_size.facet_label': {
    order: 80,
    label: 'Taille de tête de lit'
  },
  'filters.filter_nb_seat.facet_label': {
    order: 30,
    label: 'Nombre de places'
  },
  'filters.filter_christmas_theme.facet_label': {
    order: 11,
    label: 'Thème de Noël'
  },
  'filters.filter_brand.facet_label': {
    order: 10,
    label: 'Marque'
  },
  'filters.filter_capacity.facet_label': {
    order: 640,
    label: 'Capacité'
  },
  'filters.filter_form.facet_label': {
    order: 190,
    label: 'Forme'
  },
  'filters.filter_ideal_for.facet_label': {
    order: 650,
    label: 'Idéal pour'
  },
  'segmentations.category_name': {
    order: 20,
    label: 'Catégorie'
  },
  'segmentations.colors.label': {
    order: 40,
    label: 'Couleur'
  },
  'segmentations.styles.label': {
    order: 180,
    label: 'Style'
  },
  'segmentations.fabrics.label': {
    order: 170,
    label: 'Matière'
  },
  'price.filtered_amount': {
    order: 110,
    label: 'Prix'
  },
  'segmentations.dimensions.depth': {
    order: 60,
    label: 'Profondeur max'
  },
  'segmentations.dimensions.height': {
    order: 60,
    label: 'Hauteur max'
  },
  'segmentations.dimensions.width': {
    order: 60,
    label: 'Largeur max'
  },
  dimensions: {
    order: 60,
    label: 'Dimension'
  },
  more_info: {
    order: 1,
    label: 'Les offres du moment'
  },
  is_eco_selection: 'Eco selection',
  is_in_stock: 'En stock',
  is_made_in_france: 'Made in France',
  is_on_sales: 'En promotion'
};
const compactFilters = ['is_eco_selection', 'is_in_stock', 'is_made_in_france', 'is_on_sales'];
const sortReplicas = {
  price_asc: 'mdm_catalog_fr_fr_prix_asc',
  price_desc: 'mdm_catalog_fr_fr_prix_desc',
  popular: 'products_csv_import_2',
  publishdate: 'mdm_catalog_fr_fr_nouveaute'
};
const sortReplicasBeta = {
  price_asc: 'beta_production_mdm_catalog_fr_fr_prix_asc',
  price_desc: 'beta_production_mdm_catalog_fr_fr_prix_desc',
  popular: 'beta_production_mdm_catalog_fr_fr',
  publishdate: 'beta_production_mdm_catalog_fr_fr_nouveautés'
};
export { applicationID, apiKey, productIndex, betaProductIndex, categoryIndex, searchFiltersLabels, searchFiltersLabelsBeta, compactFilters, sortReplicas, sortReplicasBeta };